import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import { useNaptime } from 'bundles/naptimejs';
import EnterprisePermittedProductsV1 from 'bundles/naptimejs/resources/enterprisePermittedProducts.v1';
import inServerContext from 'bundles/ssr/util/inServerContext';
import EnterprisePermittedProductsContext from 'bundles/unified-common/contexts/EnterprisePermittedProductsContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const EnterprisePermittedProductsDataProvider = ({ children }: { children: React.ReactNode }) => {
  const program = useProgram();
  const {
    data: { permittedProducts },
    pending: loading,
  } = useNaptime<{ permittedProducts: EnterprisePermittedProductsV1 }>(
    () => ({
      // This API does not allow logged-out traffic.
      permittedProducts:
        program?.id && !inServerContext && isAuthenticatedUser()
          ? EnterprisePermittedProductsV1.get(`Program~${program?.id}`, { fields: ['accessType'] })
          : undefined,
    }),
    [program]
  );

  return (
    <EnterprisePermittedProductsContext.Provider
      value={{
        loading,
        isProgramLimitedContent: permittedProducts?.accessType === 'WHITELIST',
      }}
    >
      {children}
    </EnterprisePermittedProductsContext.Provider>
  );
};

export default EnterprisePermittedProductsDataProvider;
